/**
 * @module Directives.Paywalls
 *
 */
import template from 'ngapp/templates/views/paywalls/_pinned_posts_modal.html';
import template_icon_png from 'app/images/paywall-body-icon-templates.png';

/**
 * @class PinnedPostsModal
 *
 */
function Controller($scope, tracking) {
  $scope.modal = $scope.$props.modal;
  $scope.onCancel = onCancel;
  $scope.feature = 'Pinned Posts';
  $scope.template_icon_png = template_icon_png;

  tracking.paywalls.shown($scope.feature);

  function onCancel() {
    $scope.$props.modal.dismiss();
  }
}

Controller.$inject = ['$scope', 'core.services.tracking'];

export default {
  bindings: {
    modal: '<'
  },
  template,
  controller: Controller,
  controllerAs: '$props'
};
